module.exports = __webpack_public_path__ + "img/fundo-default.fa8e3ea2.png";